
import { activateVehicle, fetchTechniciansBeacons, reverseVehicleActivation } from "@/apiCalls/apiCalls";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle
} from "@/components/ui/dialog"
import { LoadingOutlined } from "@ant-design/icons";
import { errorNotification, successNotification } from "@/utils/Notification";
import { Button, Col, Form, Input, Modal, Row, Select, Spin } from "antd";
import { useEffect, useLayoutEffect, useState } from "react";
import { Assets } from "../assets/AssetColumns";
import { useLocation, useNavigate } from "react-router-dom";
import useAxiosPrivate from "@/context/UseAxiosPrivate";
import axios from "axios";
const { Option } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
interface ActivateVehicleProps {
    Assets: Assets
    setShowMainActivateDrawer: React.Dispatch<React.SetStateAction<boolean>>
    getAssets: any
}
const ReverseActivation: React.FC<ActivateVehicleProps> = ({ Assets, setShowMainActivateDrawer, getAssets }) => {

    const [form] = Form.useForm()
    const [submitting, setSubmitting] = useState(false)
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate();
    const onCLose = () => {
        setShowMainActivateDrawer(false)
    }


    const getClientIPAndURL = async () => {
        try {

            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }
    const onFinish = (assets: any) => {
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.post('/api/v1/crossTableOperation/reverseActivation', assets, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then(() => {
            if (isMounted) {
                successNotification(
                    "vehicle  successfully deactivated",
                    "",
                    'topRight'
                )
                getAssets()
                onCLose()
            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    }

    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2));
    }
    return (
        <>
            <Form
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{
                    asset_id: Assets.id,
                    technician_store_id: Assets.technician_store_id,
                    beacon_id: Assets.beacon_id
                }}
                hideRequiredMark
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Col span={12}>
                            <Form.Item
                                name="beacon_id"
                                label="beacon_id"
                                hidden={true}
                                rules={[{ required: true, message: 'Please enter loan id' }]}
                            >
                                <Input
                                    placeholder="Please enter loan id"
                                    className='focus:border-green-500 hover:border-green-500'

                                />
                            </Form.Item>
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="technician_store_id"
                            label="technician_store_id"
                            hidden={true}
                            rules={[{ required: true, message: 'Please enter loan id' }]}
                        >
                            <Input
                                placeholder="Please enter loan id"
                                className='focus:border-green-500 hover:border-green-500'

                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="asset_id"
                            label="asset_id"
                            hidden={true}
                            rules={[{ required: true, message: 'Please enter loan id' }]}
                        >
                            <Input
                                placeholder="Please enter loan id"
                                className='focus:border-green-500 hover:border-green-500'

                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <DialogFooter>
                        <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                            Reverse
                        </Button>
                    </DialogFooter>
                </Form.Item>
            </Form>
            <Row>
                {submitting && <Spin indicator={antIcon} />}
            </Row>
        </>
    )
}

export default ReverseActivation